import { domScriptInjectAsync, REACT_APP__CARROT_API_KEY } from "@smp/utils";
import { CarrotQuest, CarrotQuestMethod } from "custom";
import { useState } from "react";
import { useEffectOnce } from "react-use";

export const useCarrotQuest = (enabled: boolean) => {
  const [isInited, setIsInited] = useState<boolean>(false);

  const auth: CarrotQuest["auth"] = (userId, hash) => {
    window.carrotquest && window.carrotquest.auth(userId, hash);
  };

  const identify: CarrotQuest["identify"] = (params) => {
    window.carrotquest && window.carrotquest.identify(params);
  };

  const prepare = (methodName: string, _e?: any) =>
    function () {
      window.carrotquestasync.push(methodName, arguments);
    };

  const track: CarrotQuest["track"] = (eventName, params) => {
    window.carrotquest && window.carrotquest.track(eventName, params);
  };

  const open = () => {
    window.carrotquest && window.carrotquest.open();
  };

  const startConversation = async (message: string) => {
    const authToken = (window as any).carrotquest.data.auth_token;
    const userId = (window as any).carrotquest.data.user.id;
    const res = await (
      await fetch(
        `https://api.carrotquest.io/v1/users/${userId}/startconversation?body=${message}&id_as_string=true&auth_token=${authToken}`,
        {
          method: "POST",
        },
      )
    ).json();
    const id = res.data.id;
    (window as any).carrotquest.messenger.toStateNo();
    (window as any).carrotquest.messenger.toStateOpened({ id });
  };

  useEffectOnce(() => {
    (async () => {
      if (!REACT_APP__CARROT_API_KEY || !enabled) return;

      if (window.carrotquest) return setIsInited(true);

      domScriptInjectAsync("https://cdn.carrotquest.io/api.min.js", "head");

      (window as any).carrotquest = { settings: {} };

      window.carrotquestasync = [];

      const methods: CarrotQuestMethod[] = [
        "connect",
        "track",
        "identify",
        "auth",
        "oth",
        "onReady",
        "addCallback",
        "removeCallback",
        "trackMessageInteraction",
      ];

      methods.forEach(
        (methodName) =>
          ((window as any).carrotquest[methodName] = prepare(methodName)),
      );

      (window as any).carrotquest.connect(REACT_APP__CARROT_API_KEY);

      setIsInited(true);
    })();
  });

  return {
    auth,
    identify,
    isInited,
    open,
    startConversation,
    track,
  };
};
